import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useApp } from 'contexts/app';
import PricingService from 'services/pricing';

const service = new PricingService();

const MODE_LABELS = { manual: 'Cố định', auto: 'Tự động' };
const APPLY_LABELS = { all: 'Tất cả SP', tag: 'Theo tag', category: 'Theo danh mục', manual: 'Chọn thủ công' };

const useComponent = () => {
    const { showLoading, showConfirm, showNotify } = useApp();
    const navigate = useNavigate();
    const [list, setList] = useState([]);
    const [setting, setSetting] = useState({ enabled: false });
    const [settingLoaded, setSettingLoaded] = useState(false);

    useEffect(() => {
        load();
    }, []);

    const load = async () => {
        showLoading(true);
        setSettingLoaded(false);
        try {
            const [tables, s] = await Promise.all([service.list(), service.getSetting()]);
            setList(tables ?? []);
            setSetting(s ?? { enabled: false });
        } finally {
            setSettingLoaded(true);
            showLoading(false);
        }
    };

    const onAdd = () => navigate('/pricing/add');

    const onEdit = (id) => navigate(`/pricing/edit/${id}`);

    const onDelete = (id) => {
        showConfirm('Xác nhận xoá bảng giá này?', async () => {
            showLoading(true);
            await service.delete(id);
            showLoading(false);
            showNotify('Đã xoá');
            load();
        });
    };

    return { list, setting, settingLoaded, onAdd, onEdit, onDelete, navigate, MODE_LABELS, APPLY_LABELS };
};

export default useComponent;
